import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import defaultShield from '#src/assets/club/shield_none.webp';
import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, BodyS } from '#src/atoms/typography/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

const Logo = styled.img`
  width: var(--quadruple-unit);
`;

type Props = { displayName: string; pictureUrl: string | null; to: string };

export const OfficialProduct = ({ displayName, pictureUrl, to }: Props) => {
  return (
    <FullWidthContainer>
      <Horizontal>
        <Logo src={pictureUrl || defaultShield} alt={displayName} />
        <Vertical gap={0}>
          <Link to={to}>
            <BodyM as="p">{displayName}</BodyM>
          </Link>
          <BodyS as="p" color="var(--c-nd-600)">
            <FormattedMessage {...glossary.officiallyLicensedProduct} />
          </BodyS>
        </Vertical>
      </Horizontal>
    </FullWidthContainer>
  );
};
